module.exports = __webpack_public_path__ + "img/Connections.48142c9e.jpg";